import angular from 'angular';

import AsyncDirective, { selector } from './async.directive';

export default angular
    .module('application.directive.async', [])
    .directive(selector, AsyncDirective);



// WEBPACK FOOTER //
// ./src/application/directive/async/index.js